import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { Inspection, Inspector, ListFilters, ListResults, Vendor } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class VendorService {
  constructor(protected http: HttpClient) {}

  public list(filters?: ListFilters) {
    return this.http.get<ListResults<Vendor>>(`${env.APIUrl}/vendor`, { params: filters as any });
  }

  public get(id: number) {
    return this.http.get<Vendor>(`${env.APIUrl}/vendor/${id}`).toPromise();
  }

  public archived(filters?: ListFilters) {
    return this.http.get<ListResults<Vendor>>(`${env.APIUrl}/vendor/archived`, { params: filters as any });
  }

  public archive(id: number) {
    return this.http.put<Vendor>(`${env.APIUrl}/vendor/${id}/archive`, null).toPromise();
  }

  public restore(id: number) {
    return this.http.put<Vendor>(`${env.APIUrl}/vendor/${id}/restore`, null).toPromise();
  }

  public remove(id: number) {
    return this.http.delete<Vendor>(`${env.APIUrl}/vendor/${id}`).toPromise();
  }

  public edit(id: number, vendor: Vendor) {
    return this.http.put<Vendor>(`${env.APIUrl}/vendor/${id}`, vendor).toPromise();
  }

  public create(vendor: Vendor) {
    return this.http.post<Vendor>(`${env.APIUrl}/vendor`, vendor).toPromise();
  }

  public inspectors(vendorId: number, search = '', distanceTo = '') {
    return this.http.get<Inspector[]>(`${env.APIUrl}/vendor/${vendorId}/inspectors`, {
      params: { search, distanceTo },
    });
  }

  public inspections(vendorId: number) {
    return this.http.get<Inspection[]>(`${env.APIUrl}/vendor/${vendorId}/inspections`);
  }
  public count() {
    return this.http.get<{ active: boolean; count: number }[]>(`${env.APIUrl}/vendor/count`).toPromise();
  }
}
